import { EncryptStorage } from "storage-encryption";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const secretKey: string= process.env.REACT_APP_SECRET_KEY!
export const encryptStorage = new EncryptStorage(secretKey);


